/* @flow */
import React from 'react';
import type { Node } from 'react';
import styled from 'styled-components';
import Button from '../../Button';

const Root = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	box-sizing: border-box;
	width: 100%;
	max-width: 475px;
	padding: 30px;
	font-weight: 500;

	@media (max-width: 600px) {
		max-width: 90vw;
	}
`;

const Message = styled.p`
	margin: 20px 0;
	font-size: 18px;
	line-height: 1.33;
	color: #333;
`;

type TProps = {
	message: string,
	buttonText: string,
	onClick: () => {},
};

const ConfirmPopUp = ({ message, buttonText, onClick }: TProps): Node => (
	<Root>
		<Message>{message}</Message>
		<Button rounded small onClick={onClick}>
			{buttonText}
		</Button>
	</Root>
);

export default ConfirmPopUp;
